import styles from "../../../styles/Components/new-dashboard/my-tasks/TasksList.module.css";
import { useSelector } from "react-redux";
import { Checkbox } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";

const TaskItem = ({ label, status }) => {
  const [isChecked, setIsChecked] = useState(status === "Done");

  const lowerLabel = label.toLowerCase();

  const isDone = status === "Done";
  const actionText = lowerLabel?.includes("exchange")
    ? "Integrate"
    : lowerLabel?.includes("bot")
      ? "Test"
      : lowerLabel?.includes("signal")
        ? "View"
        : lowerLabel?.includes("insight")
          ? "Check"
          : "See";

  const linkPath =
    actionText === "Integrate"
      ? `/portfolio`
      : actionText === "Test"
        ? "/bot-automation"
        : actionText === "View"
          ? "/ai-assistant"
          : actionText === "Check"
            ? "/insight"
            : "/dashboard";

  const checkTaskHandler = (e) => {
    return;
    // if (isDone) return;
    //
    // setIsChecked(e.target.checked);
  };

  return (
    <li className={styles.taskItem}>
      <div className={styles.taskLabel}>
        <Checkbox
          checked={isChecked}
          onChange={checkTaskHandler}
          id={label}
          className={styles.checkBox}
        />
        <label htmlFor={label}>
          {label} {isDone && "(Completed)"}
        </label>
      </div>

      <Link
        className={`${styles.btn} ${!isDone ? styles.notCompleted : ""}`}
        to={linkPath}
      >
        {actionText} {isDone ? "Again" : "Now"}
      </Link>
    </li>
  );
};

function TasksList() {
  const {
    dashboard: { taskInfo },
  } = useSelector((state) => state);

  const { tasks_summary = {}, recommended_next_steps: nextSteps = [] } =
    taskInfo;

  const tasksList = Object.keys(tasks_summary);

  return (
    <div className={styles.container}>
      <ul className={styles.tasks}>
        {tasksList?.map((label) => (
          <TaskItem key={label} label={label} status={tasks_summary?.[label]} />
        ))}
      </ul>

      {nextSteps.length > 0 && (
        <div className={styles.recommendation}>
          <strong>Recommended Next Step:</strong>
          {nextSteps.map((step, i) => (
            <em key={i} style={{ marginLeft: ".5rem" }}>
              {i + 1}. {step}
            </em>
          ))}
        </div>
      )}
    </div>
  );
}

export default TasksList;
